import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

interface Breadcrumb {
  label: string;
  url: string;
}

interface NavigationPage { title: string; link: string; }

@Component({
  selector: 'app-assurance-tous-risques-chantier',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-tous-risques-chantier.component.html',
  styleUrls: ['./assurance-tous-risques-chantier.component.scss']
})
export class AssuranceTousRisquesChantierComponent {
  title = 'Assurance Tous Risques Chantier (TRC)';
  subtitle = 'Couvrez tous les risques pendant vos travaux';
  heroImage = 'assets/images/hero-trc.jpg';

  breadcrumbs: Breadcrumb[] = [
    { label: 'Entreprises', url: '' },
    { label: 'Assurance Tous Risques Chantier', url: '' }
  ];

  prevPage: NavigationPage = { title: 'Assurance Dommages-Ouvrage Maître',
    link: '/entreprises/assurance-dommages-ouvrage-maitre'
  };

  nextPage: NavigationPage = { title: 'Assurance Multirisque Pro',
    link: '/entreprises/assurance-multirisque-pro'
  };
}
